import styled from 'styled-components'
import { stoColor, stoMedia, stoRadius, stoShadow, stoSpace, stoType } from 'constants/stoTheme'
import { flatInTabCard } from './Performance.styles'

/** Figma 3990:77340: the bordered card holding the composition. */
export const NavCard = styled.div`
  container-type: inline-size;
  display: flex;
  flex-direction: column;
  gap: ${stoSpace[5]};
  padding: ${stoSpace[6]};
  background: ${stoColor.surface};
  border: 1px solid ${stoColor.borderSubtle};
  border-radius: ${stoRadius.lg};
  box-shadow: ${stoShadow.xs};

  ${stoMedia.belowDesktop} {
    padding: ${stoSpace[4]};
  }
  ${flatInTabCard}
`

/** The view's name on the left, Latest / Historical on the right. */
export const NavHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: ${stoSpace[3]};
`

/** Figma "NAV composition": the one view, as a raised white tab with nothing to switch to. */
export const ViewLabel = styled.span`
  padding: ${stoSpace[1]} ${stoSpace[4]};
  border: 1px solid ${stoColor.borderSubtle};
  border-radius: ${stoRadius.sm};
  background: ${stoColor.surface};
  box-shadow: ${stoShadow.sm};
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: 0.6px;
  color: ${stoColor.textPrimary};
`

export const PeriodRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${stoSpace[2]};
`

/** Figma "Button Outlined" when chosen, "Button Text" otherwise: the Historical menu's look. */
export { MenuButton as PeriodButton } from 'components/sto/OptionMenu'

/** Donut beside the legend; stacked when the card is narrow. */
export const Composition = styled.div`
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
  gap: ${stoSpace[8]};

  @container (max-width: 559px) {
    grid-template-columns: minmax(0, 1fr);
    justify-items: center;
    gap: ${stoSpace[6]};
  }
`

export const CentreValue = styled.span`
  font-size: 24px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0.4px;
  color: ${stoColor.textPrimary};
`

export const CentreLabel = styled.span`
  margin-top: ${stoSpace[1]};
  font-size: 11px;
  line-height: 16px;
  letter-spacing: 1.6px;
  text-transform: uppercase;
  color: ${stoColor.textPrimary};
`

export const CentreDate = styled.span`
  font-size: 12px;
  font-weight: 700;
  line-height: 18px;
  color: ${stoColor.primary};
`

export const Legend = styled.div`
  width: 100%;
`

export const LegendList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`

export const LegendRow = styled.li`
  ${stoType.bodySmTight};
  display: flex;
  align-items: center;
  gap: ${stoSpace[3]};
  padding: 10px 0;
  border-bottom: 1px solid ${stoColor.borderSubtle};
  font-size: 14px;
  line-height: 20px;
  color: ${stoColor.textPrimary};
`

export const LegendDot = styled.span<{ $color: string }>`
  flex: 0 0 auto;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${({ $color }) => $color};
`

export const LegendLabel = styled.span`
  flex: 1 1 auto;
  min-width: 0;
`

export const LegendValue = styled.span`
  flex: 0 0 auto;
  font-weight: 600;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
`

export const Total = styled.p`
  margin: 0;
  padding-top: ${stoSpace[4]};
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-align: right;
  color: ${stoColor.textPrimary};
`
